/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_POLICY_DETAIL = gql`
  query Query($input: GetPolicyDetailInput!) {
    getPolicyDetail(input: $input) {
      policyNumber
      discountedPremium
      policyId
      productDefination
      purchasedAt
      countryToBeInsured
      purchasedAt
      type
      pdf
      premium
      coverage
      minDue
      status
      payments {
        status
        amount
        comment
        paymentMode
      }
      purchasedBy {
        email
        firstName
        vuid
        lastName
        address {
          addressLine1
          city
          country
        }
        occupation
        primaryContactNo
      }
      useOfProceeds {
        selected
        value
      }
      termsOfUse {
        selected
        value
      }
      benificiaryDetail {
        address {
          addressLine2
          city
          addressLine1
          country
        }
        email
        firstName
        lastName
        mobileNo
      }
    }
  }
`;
